<app-chart *ngIf='openChart' (onCloseChartToParent)='closeChartModals()' [ChartData]="ChartData" [subTitle]="subTitle"
    [universalAuditID]="universalAuditID" [component]="component"></app-chart>
<div id="leftdiv" class="leftdiv">
    <span id="spandrp" nglDropdown [(open)]="openBtnRateIntegrity">
        <section class="overAuditGrid">&nbsp;

            <div id="leftcontrol" class="leftControls">
                <a *ngIf='!quickAuditEnabled' title="Upload File" [routerLink]="['../create']" title="Create Rate Audit">
                    <span id="spancrl" class="cvt-primary ri-new-audit cvt-icon-addCircleFilled"></span>
                </a>
                <span *ngIf='quickAuditEnabled' id="spancrl" class="cvt-primary ri-new-audit cvt-icon-addCircleFilled"
                    nglDropdownTrigger></span>
            </div>
            <div *ngIf='quickAuditEnabled' id="leftdivdrp"
                class="slds-dropdown slds-dropdown--left rvrs-drpdwn k-primary ">
                <ul class="" role="menu">
                    <li id="liid" class="" *ngFor="let item of auditCreateMapping;">
                        <a id="anchrid" [routerLink]="[item.path]" role="menuitem"
                            (click)="openBtnRateIntegrity=false;">
                            <p id="pid" class="slds-truncate rvrs-para">{{item.text}}</p>
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </span>
</div>
<div>
    <section class="overAuditGrid">&nbsp;
        <div class="filterGroup"> Filter: <kendo-datepicker id="dateStart" (valueChange)="onStartDateChange($event)"
                [value]="initialFilterStartDate"></kendo-datepicker> To
            <kendo-datepicker id="dateEnd" [value]="initialFilterEndDate" (valueChange)="onEndDateChange($event)">
            </kendo-datepicker>
            Account Name
            <kendo-autocomplete id="ddlAccountNames" [data]="filteredAccountNameList" [suggest]="true"
                [filterable]="true" [minLength]="3" [placeholder]="'Search...'" (filterChange)="handleFilter($event)"
                (valueChange)="accountNameFilterChange($event)">
            </kendo-autocomplete>
        </div>
    </section>
</div>
<div>
    <app-alert></app-alert>
</div>
<div class="auditGrid">
    <kendo-grid id="kendoGrid" [data]="viewObserver | async" [pageSize]="state.take" [pageable]="{buttonCount: 5,info:norecords}"
        [skip]="state.skip" [sort]="state.sort" [sortable]="true" [pageable]="true" [scrollable]="'none'"
        [selectable]="true" [selectedKeys]="selectedAudit" [kendoGridSelectBy]="'UniversalAuditID'"
        (dataStateChange)="dataStateChange($event)" (selectionChange)="selectionChange($event)">
        <kendo-grid-column title="" [width]="20">
            <ng-template kendoGridHeaderTemplate let-column>
                &emsp;<span *ngIf='isSuperUser'>&emsp;&emsp;&nbsp;</span>
            </ng-template>
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
                <div class="raui-grid-buttons ">
                    <a *ngIf="dataItem.Status == 1 " src="#" title="Pending"><span
                            class="cvt-icon-dateTimeQuestion grid-cmd-icons"></span></a>
                    <img *ngIf="dataItem.Status == 2" src="../../../assets/download.gif" [width]="33" title="Running" />
                    <a *ngIf="dataItem.Status == 3 " src="#"><span class="cvt-icon-completed grid-cmd-icons"
                            title="Audit Completed"></span></a>
                    <a *ngIf="dataItem.Status == 4 " src="#" title="Error running Audit"><span
                            class="cvt-icon-error grid-cmd-icons"></span></a>
                    <a *ngIf="dataItem.Status == 5 || dataItem.Status == 7" src="#"
                        title="Click to approve to run audit"><span class="cvt-icon-checkIn grid-cmd-icons"
                            (click)="approveAuditToRun(dataItem.AuditID)"></span></a>
                    <a *ngIf="dataItem.Status == 6 || dataItem.Status == 8" src="#"
                        title="Audit Scheduled to process on  {{dataItem.ScheduledRunDate|date: 'short'}}"><span
                            class="cvt-icon-countdown grid-cmd-icons"></span></a>
                    <a *ngIf='isSuperUser ' src="#" title="Delete Audit"><span class="cvt-icon-trash grid-cmd-icons"
                            (click)="onDelete(dataItem.AuditID)"></span></a>
                    <a *ngIf='isSuperUser && !dataItem.isQuickAudit' src="#" title="Download Audit"><span
                            class="cvt-icon-download grid-cmd-icons"
                            (click)="onDownloadRateAuditFile(dataItem.AuditID)"></span></a>
                    <a *ngIf="dataItem.Status == 3  && dataItem.QuickAuditRerun" src="#" title="Rerun Audit"><span
                            class="cvt-icon-sync grid-cmd-icons"
                            [routerLink]="['../quickcreate',{rerunID:dataItem.QuickAuditID}]"></span></a>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="UniversalAuditID" [width]="1">
            <ng-template kendoGridHeaderTemplate let-column>
                <span>Audit ID</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
                    src="../../../assets/sort-button.png" />
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.QuickAuditID ? dataItem.QuickAuditID : dataItem.UniversalAuditID}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="10">
            <ng-template kendoGridHeaderTemplate let-column>
                <div>&emsp;&emsp;&emsp;&nbsp;</div>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="raui-grid-buttons ">
                    <a src="#" title="View Chart"><span class="cvt-icon-reports grid-cmd-icons"
                            (click)="onDisplayChart(dataItem.AuditID,dataItem.QuickAuditID?dataItem.QuickAuditID:dataItem.UniversalAuditID)"></span></a>
                    <a src="#" title="Reports"><span class="cvt-icon-document grid-cmd-icons"
                            (click)="onShowReports(dataItem.AuditID,dataItem.LengthOfStay)"></span></a>
                    <a [routerLink]="['../review', {auditId:dataItem.AuditID,universalId:dataItem.QuickAuditID?dataItem.QuickAuditID:dataItem.UniversalAuditID,accountName:dataItem.CustomerAccountName}]"
                        title="Notification"><span class="cvt-icon-htmlEmail grid-cmd-icons"></span></a>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="DateImported" title="Date Uploaded" [width]="20">
            <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field"
                    style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                {{  dataItem.DateImported | date:'medium'  }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CustomerAccountName" title="Account Name" [width]="20">
            <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field"
                    style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="PropertyCount" title="Properties" [width]="5">
            <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field"
                    style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="NotificationName" title="Template" [width]="20">
            <ng-template kendoGridHeaderTemplate let-column>
                <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field"
                    style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column-group [locked]="false" [width]="200" headerClass="raui-gds-audited-hd" >
            <ng-template kendoGridHeaderTemplate let-column>
                <div style="width: 100%;text-align:center;">GDS Audited</div>
            </ng-template>
            <kendo-grid-column field="AuditAmadeus" title="Am" headerClass="raui-gds-audited" [width]="4">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span
                        *ngIf="dataItem.Status == 2">{{dataItem.AuditAmadeus?(dataItem.AmadeusProgress+'%'):''}}</span>
                    <span *ngIf="dataItem.Status != 2"><span *ngIf="dataItem.AuditAmadeus"
                            class="cvt-icon-check grid-status-icons"></span></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AuditApollo" title="Ap" headerClass="raui-gds-audited" [width]="4">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span *ngIf="dataItem.Status == 2">{{dataItem.AuditApollo?(dataItem.ApolloProgress+'%'):''}}</span>
                    <span *ngIf="dataItem.Status != 2"><span *ngIf="dataItem.AuditApollo"
                            class="cvt-icon-check grid-status-icons"></span></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AuditGalileo" title="Ga" headerClass="raui-gds-audited" [width]="4">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span
                        *ngIf="dataItem.Status == 2">{{dataItem.AuditGalileo?(dataItem.GalileoProgress+'%'):''}}</span>
                    <span *ngIf="dataItem.Status != 2"><span *ngIf="dataItem.AuditGalileo"
                            class="cvt-icon-check grid-status-icons"></span></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AuditSabre" title="Sa" headerClass="raui-gds-audited" [width]="4">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span *ngIf="dataItem.Status == 2">{{dataItem.AuditSabre?(dataItem.SabreProgress+'%'):''}}</span>
                    <span *ngIf="dataItem.Status != 2"><span *ngIf="dataItem.AuditSabre"
                            class="cvt-icon-check grid-status-icons"></span></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="AuditWorldspan" title="Wo" headerClass="raui-gds-audited" [width]="4">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span
                        *ngIf="dataItem.Status == 2">{{dataItem.AuditWorldspan?(dataItem.WorldspanProgress+'%'):''}}</span>
                    <span *ngIf="dataItem.Status != 2"><span *ngIf="dataItem.AuditWorldspan"
                            class="cvt-icon-check grid-status-icons"></span></span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group>
    </kendo-grid>

</div>

<div kendoDialogContainer *ngIf='kendoDialog'></div>
<app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal'
    [dialogTitle]="dialogTitle" [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="dialogTextLine2"
    [primaryButtonText]="primaryButtonText" [secondaryButtonText]="secondaryButtonText"></app-modal>
<app-report-dialog *ngIf="showReportDialog" [AuditId]="reportDlgAuditId" [LOSAudit]="reportDlgLOS"
    [AuditType]="'rateAudit'" (done)="reportDialogDone()"></app-report-dialog>
